import type { ReactNode } from 'react';
import { ScreenHeader } from './ScreenHeader';

interface FormPageLayoutProps {
  title: string;
  subtitle?: ReactNode;
  onBack: () => void;
  children?: ReactNode;
  maxWidthClassName?: string;
  loading?: boolean;
}

/** Full-screen form page shell (stack navigation, ScreenHeader, scroll in Layout main). */
export function FormPageLayout({
  title,
  subtitle,
  onBack,
  children,
  maxWidthClassName = 'max-w-[800px]',
  loading = false,
}: FormPageLayoutProps) {
  return (
    <div className={`page-container ${maxWidthClassName} pb-20 min-w-0`}>
      <ScreenHeader title={title} subtitle={subtitle} onBack={onBack} />
      {loading ? (
        <div className="flex justify-center py-16">
          <div className="spinner h-10 w-10" />
        </div>
      ) : (
        children
      )}
    </div>
  );
}
